import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { DataMigrationService } from "../Services/dataMigration.service";
import { Router } from "@angular/router";

@Component({
  selector: 'formDailog',
  templateUrl:'./formDialog.component.html',
  standalone: false
})
export class FormDialogComponent {
  answer: string = '';


  constructor(public dialogRef: MatDialogRef<FormDialogComponent>, public data: DataMigrationService, private router: Router) { }

  onOkClick() {
    this.dialogRef.close();
    this.router.navigate(['']);
  }
}
